<sm-title-bar pageTitle="Notifications" *ngIf="!loader"></sm-title-bar>

<div *ngIf="!loader">
  <div class="row" *ngIf="messageLIst.length > 0 && !loader">
    <div class="col-sm-12">
      <mat-card appearance="outlined" class="open_trt">
        <div class="fl_orders" *ngFor="let item of messageLIst">
          <div class="top_section_order">
            <div class="notif-container">
              <!-- Sender Image -->
              <div class="notif-image">
                <img *ngIf="(item.senderImgThumbUrl && item.senderImgThumbUrl != 'null') && (item.notifyType != 'onBusinessActivation' && item.notifyType != 'adminMessage')" [src]="item.senderImgThumbUrl" />
                <img *ngIf="item.notifyType == 'onBusinessActivation' || item.notifyType == 'adminMessage'" src="../../../../assets/images/app_icon.png" />
                <div class="booking-initial" *ngIf="(!item.senderImgThumbUrl || item.senderImgThumbUrl == 'null') && (item.notifyType != 'onBusinessActivation' && item.notifyType != 'adminMessage')"><mat-icon class="not_icn">notifications</mat-icon></div>
                <!-- <div class="booking-initial" *ngIf="item.notifyType == 'onBusinessActivation' || item.notifyType == 'adminMessage'"><mat-icon class="not_icn">notifications</mat-icon></div> -->
                <!-- <img *ngIf="!item.senderImgThumbUrl || item.senderImgThumbUrl == 'null'" src="../../../../assets/images/photo.png" /> -->
              </div>
              <!-- Notification Content -->
              <div class="notif-content">
                <h3 class="notif-title">
                  {{ item.title }}
                </h3>
                <p class="notif-message">
                  {{ item.description }}
                </p>
                <div class="notif-date">
                  {{ item.creationDate | date:'MMM d, y - h:mm a' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <!-- No Notifications -->
  <div class="row" *ngIf="messageLIst.length == 0 && !loader">
    <div class="col-sm-12">
      <div class="notif-empty">
        <div class="notif-empty-content">
          <div class="notif-icon">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
              width="512" height="512" x="0" y="0" viewBox="0 0 24 24"
              style="enable-background:new 0 0 512 512" xml:space="preserve">
              <g>
                <path
                  d="M12 21.75a2.731 2.731 0 0 1-2.378-1.372.75.75 0 0 1 1.3-.756 1.287 1.287 0 0 0 2.164 0 .75.75 0 1 1 1.3.756A2.731 2.731 0 0 1 12 21.75zm8.675-3.425a.751.751 0 0 0-.089-.793 9.219 9.219 0 0 1-1.841-5.032V8.995a6.745 6.745 0 0 0-13.49 0V12.5a9.219 9.219 0 0 1-1.841 5.032A.751.751 0 0 0 4 18.75h16a.75.75 0 0 0 .675-.425zM6.755 12.5V8.995a5.245 5.245 0 0 1 10.49 0V12.5a9.908 9.908 0 0 0 1.368 4.75H5.387a9.908 9.908 0 0 0 1.368-4.75z"
                  fill="#b1b1b1" opacity="1" data-original="#000000">
                </path>
              </g>
            </svg>
          </div>
          <p class="notif-empty-text">
            Notifications will be shown here as <br /> they arrive.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
